"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var config_1 = require("./utils/config");

var defaultValues = {
  domains: config_1.defaultDomains,
  secondLevelDomains: config_1.defaultSecondLevelDomains,
  topLevelDomains: config_1.defaultTopLevelDomains
};
exports.defaultValues = defaultValues;

var suggest_1 = require("./suggest");

exports.suggest = suggest_1.suggest;

var validate_1 = require("./validate");

exports.validate = validate_1.validate;